class MattressEmbedForm extends HTMLElement {
  constructor() {
    super();

    this.currentSize = this.getCurrentSize();
    this.currentType = this.getCurrentType();
    this.data = this.parseProductData(this);
    this.types = this.querySelectorAll(".mattress-embed__mattress-type input");
    this.sizes = this.querySelectorAll(".mattress-embed__mattress-size input");
    this.formInput = this.querySelector(".mattress-embed__variant-id");
    this.viewMore = this.querySelector(".mattress-embed__view-more");
    this.price = this.querySelector(".mattress-embed__price");
    this.salePrice = this.querySelector(".mattress-embed__price--sale");

    this.disableUnavailableSizes();

    this.types.forEach((type) =>
      type.addEventListener("click", this.onMattressTypeChange.bind(this))
    );

    this.sizes.forEach((size) =>
      size.addEventListener("click", this.onSizeChange.bind(this))
    );
  }

  parseProductData() {
    const dataContent = this.querySelector(".mattress-embed__data").textContent;
    return JSON.parse(dataContent);
  }

  getCurrentSize() {
    return this.querySelector(".mattress-embed__mattress-size input:checked")
      .value;
  }

  getCurrentType() {
    return this.querySelector(".mattress-embed__mattress-type input:checked")
      .value;
  }

  isSizeAvailable(size) {
    const targetVariant = this.findVariantBySize(size);

    return (
      targetVariant &&
      (targetVariant.available || targetVariant.inventory_policy === "continue")
    );
  }

  disableUnavailableSizes() {
    this.sizes.forEach((element) => {
      element.disabled = !this.isSizeAvailable(element.value);
    });
  }

  selectFirstAvailableSize() {
    const currentSelector = this.querySelector(
      ".mattress-embed__mattress-size input:checked"
    );

    if (currentSelector.disabled)
      Array.from(this.sizes)
        .find(({ disabled }) => !disabled)
        .click();
  }

  findVariantBySize(size) {
    return this.data[this.currentType].variants.find(
      ({ option1 }) => option1.replace(/\s\(.*\)/, "").trim() === size
    );
  }

  updateViewMore() {
    const handle = this.data[this.currentType].handle;
    const variant = this.findVariantBySize(this.currentSize);
    this.viewMore.href = `/products/${handle}?variant=${variant.id}`;
  }

  updateFormInput() {
    const targetVariant = this.findVariantBySize(this.currentSize);
    this.formInput.value = targetVariant.id;
  }

  updatePrice() {
    const { compare_at_price, price } = this.findVariantBySize(
      this.currentSize
    );

    const priceContainer = this.price.closest(
      ".mattress-embed__price-container"
    );

    if (compare_at_price > price) {
      this.price.innerHTML = "$" + window.formatMoney(compare_at_price);
      this.salePrice.innerHTML = "$" + window.formatMoney(price);
      this.salePrice.classList.remove("hidden");

      if (priceContainer)
        priceContainer.classList.add("mattress-embed__price-container--sale");
    } else {
      this.salePrice.classList.add("hidden");
      this.price.innerHTML = "$" + window.formatMoney(price);

      if (priceContainer)
        priceContainer.classList.remove(
          "mattress-embed__price-container--sale"
        );
    }
  }

  updateSectionImage() {
    const sectionImage = this.parentElement.querySelector(
      ".mattress-embed__image"
    );

    if (sectionImage.childElementCount < 2) return;
    else
      sectionImage
        .querySelectorAll("img")
        .forEach((image) =>
          image.classList.toggle(
            "hidden",
            image.dataset.product !== this.currentType
          )
        );
  }

  onMattressTypeChange(selectedOption) {
    this.currentType = selectedOption.target.value;
    this.parentElement.dataset.selectedProduct = this.currentType;

    this.updateSectionImage();
    this.disableUnavailableSizes();
    this.selectFirstAvailableSize();
    this.updateFormInput();
    this.updateViewMore();
    this.updatePrice();
  }

  onSizeChange(selectedOption) {
    this.currentSize = selectedOption.target.value;
    this.updateFormInput();
    this.updateViewMore();
    this.updatePrice();
  }
}

if (!customElements.get("mattress-embed-form"))
  customElements.define("mattress-embed-form", MattressEmbedForm);
